import { PERSONAL_JOURNAL } from "../constants/url";
import { useAppDispatch } from "../hooks/reduxHooks";
import { catchErrors } from "../utils/catchErrors";
import { generateFormData } from "../utils/generateFormData";
import { getApiCall, genericApiCall } from "../utils/servicesBaseUtil";
import { message } from "antd";

export const getPersonalJournalApi = ({
  survey_id,
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = `${PERSONAL_JOURNAL}?survey_id=${survey_id}`;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const savePersonalJournalApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = PERSONAL_JOURNAL;
    genericApiCall({
      url: url,
      method: "POST",
      data: data,
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const deletePersonalJournalApi = ({
  survey_id,
  entry_id,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = `${PERSONAL_JOURNAL}/${entry_id}`;
    genericApiCall({
      url: url,
      method: "DELETE",
      data: { survey_id: survey_id },
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
